import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Availabilities} from '../../_constants/availabilities';
import {MenuItemInventoryService} from '../../_services/menu-item-inventory.service';
import {OrganizationTerminalService} from '../../_services/organization-terminal.service';
import {BaseMenuItemInventoryComponent} from '../base-menu-item-inventory.component';
import {ModalController} from '@ionic/angular';
import {ImageCacheService} from '../../_services/image-cache.service';
import {Constants} from '../../_constants/constants';
import {PickupLocationMenuService} from '../../_services/pickup-location-menu.service';
import {MenuCategory} from '../../_models/menu-category';
import {PickupLocationMenu} from '../../_models/pickup-location-menu';

@Component({
    selector: 'bb-menu-item-image',
    templateUrl: './menu-item-image.component.html',
    styleUrls: ['./menu-item-image.component.scss'],
})
export class MenuItemImageComponent extends BaseMenuItemInventoryComponent implements OnInit, OnDestroy {
    @Input() screenWidth: number;
    @Input() nameOverride = 'Misc';
    @Input() imageAddressOverride: string;
    @Input() orderType: string;
    @Input() hideImage = false;
    @Input() showInventory = false;
    @Input() orderDisplay = false;
    @Input() showImageOverride = false;
    @Input() menuCategory: MenuCategory;
    @Input() color = '#ECECEC';
    @Input() contrastColor = '#000000';
    @Output() imageLoaded = new EventEmitter<any>();
    imageContainer: any;
    availabilities = Availabilities;
    pickupLocationMenu: PickupLocationMenu;
    kegRadius = 10;

    imageSrc;

    resizeObserver: ResizeObserver;
    Constants = Constants;

    constructor(
        private pickupLocationMenuService: PickupLocationMenuService,
        private imageCacheService: ImageCacheService,
        modalController: ModalController,
        menuItemInventoryService: MenuItemInventoryService,
        organizationTerminalService: OrganizationTerminalService
    ) {
        super(modalController, menuItemInventoryService, organizationTerminalService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.pickupLocationMenu = this.pickupLocationMenuService.currentValue;

        if (!this.showImageOverride) {
            this.hideImage = !this.pickupLocationMenuService.showImagesCurrent;
            this.subscribe(this.pickupLocationMenuService.showImages.subscribe(s => this.hideImage = !s));
        }

        this.imageSrc = this.imageCacheService.getImage(!!this.imageAddressOverride ? this.imageAddressOverride : (!!this.menuItem
            ? this.menuItem.imageAddress
            : ''));

        if (!this.menuCategory && !!this.menuItem && !!this.pickupLocationMenu
            && !!this.pickupLocationMenu.menu && !!this.pickupLocationMenu.menu.menuCategories && !!this.menuItem) {
            this.menuCategory = this.pickupLocationMenu.menu.menuCategories
                .find(c => !!c.menuItems && c.menuItems.some(i => i.menuItem.id === this.menuItem.id));
        }

        if (!!this.menuCategory) {
            this.color = !!this.menuCategory.color ? this.menuCategory.color : this.color;
            this.contrastColor = !!this.menuCategory.contrastColor ? this.menuCategory.contrastColor : this.contrastColor;
        }
    }

    ngOnDestroy(): void {
        if (!!this.resizeObserver) {
            this.resizeObserver.unobserve(this.imageContainer);
            this.resizeObserver.disconnect();
        }
        super.ngOnDestroy();
    }

    @ViewChild('imageContainer') set content(element) {
        if (!!element && this.isKegInventory()) {
            this.imageContainer = element.nativeElement;
            if (!this.resizeObserver) {
                this.resizeObserver = new ResizeObserver(entries => {
                    const width = this.imageContainer.offsetWidth;
                    if (width < 170) {
                        this.kegRadius = 15;
                    } else if (width >= 170 && width < 185) {
                        this.kegRadius = 16;
                    } else if (width >= 185 && width < 200) {
                        this.kegRadius = 17;
                    } else {
                        this.kegRadius = 18;
                    }
                });

                this.resizeObserver.observe(this.imageContainer);
            }
        } else if (!!this.resizeObserver) {
            this.resizeObserver.unobserve(this.imageContainer);
            this.resizeObserver.disconnect();
        }
    }
}
